'use strict';
import $ from 'jquery';
import 'bootstrap';

export default class Footer {
    static init() {
        $('footer .footer-sidebar h3').matchHeight();
        Footer.footerSubscribeTooltip();
    }

    static footerSubscribeTooltip() {
        if ($('.footer-subscribe-banner').length > 0) {
            const form = $('.footer-subscribe-banner').find('.hubspot-form');
            console.log("form: ", form);
            let counter;
            form.on('onFormReady', () => {
                const text = $('.footer-subscribe-banner').find('.legal-consent-container p').html();
                console.log("text: ", text);
                const input = $('.footer-subscribe-banner input[type=email]');
                input.tooltip({
                    // selector: '.footer-subscribe-banner input[type=email]',
                    trigger: 'manual',
                    placement: 'auto',
                    html: true,
                    title: text,
                    template: '<div class="tooltip footer-subscribe-banner-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
                    // container: 'body',
                    delay: {
                        show: 50,
                        hide: 500,
                    }
                }).on("mouseenter", function (e) {
                    var _this = this;
                    e.preventDefault();
                    clearTimeout(counter);
                    $('[rel="tooltip"]').not(_this).tooltip('hide');
                    counter = setTimeout(function () {
                        if ($(_this).is(':hover')) {
                            $(_this).tooltip("show");
                        }
                        $(".tooltip").on("mouseleave", function () {
                            $(_this).tooltip('hide');
                        });
                    }, 400);

                }).on("mouseleave", function () {
                    var _this = this;

                    setTimeout(function () {
                        if (!$(".tooltip:hover").length) {
                            if (!$(_this).is(':hover')) // change $(this) to $(_this) 
                            {
                                $(_this).tooltip('hide');
                            }
                        }
                    }, 200);
                });
                // form.find('input[type=email]').tooltip({
                //     html: true,
                //     title: text,
                //     delay: {
                //         hide: 500,
                //     }
                // });
            });
        }
    }
}

